export default __webpack_public_path__ + "210e39c9e5653c7cb19bf25fc1cf49bd.svg";